import Footer from "../../components/Footer";
import LanImg_2 from "../../assets/img/ourStory.png";
import LanIcon_3 from "../../assets/img/Black.png";
import "../style.css";
import { useParams } from "react-router-dom";
import LanImg_1 from "../../assets/img/pass.png";
import LanguageLearnMore from "./LanguageLearnMore";
export default function PasswordEnglishLanguageTest() {
  const { id } = useParams();
  const learnMoreData = {
    pageName: "PasswordEnglishLanguageTest",
    heroSection: {
      header1: "Password Skills Plus for",
      header2: "university entry",
      desc: "Password Skills Plus is an internationally recognised English language proficiency test aligned with the Common European Framework of Reference for Languages.",
      rightImg: LanImg_1,
    },
    aboutTestSection: {
      img: LanImg_2,
      header: "What is the Password Skills Plus test?",
      desc1:
        "Password Skills Plus is an English language proficiency test that fulfils all Global Home Office requirements for admission to undergraduate and postgraduate courses. It is also accepted by universities and colleges in over 100 countries around the world. A full list of institutions that accept the Password Skills Plus test can be found on the official website",
      desc2:
        "Aligned to the Common European Framework of Reference for Languages (CEFR), the Password Skills Plus test assesses your English reading, writing, listening, and speaking skills. You can take the test from home at any date and time and receive your results via email within five working days.",
    },
    blueCardSection: {},
    differenceSection: {
      header: "What makes the Password Skills Plus test different?",
      desc: "Password Skills Plus stands out for its extremely high levels of accuracy in testing and helps you assess your readiness to study abroad.",
      cards: [
        {
          img: LanIcon_3,
          header: "Multiple testing options",
          desc: "You can choose to take the LanguageCert Academic or the Academic SELT test, depending on your requirements",
        },
        {
          img: LanIcon_3,
          header: "Real-world application",
          desc: "The test English proficiency based on everyday situations, helping you develop practical language skills",
        },
        {
          img: LanIcon_3,
          header: "Fast and reliable results",
          desc: "You can get your official LanguageCert score within five working days of completing the test",
        },
        {
          img: LanIcon_3,
          header: "Available worldwide",
          desc: "LanguageCert exams are available in over 200 countries and territories and accepted by institutions in over 100 countries worldwide",
        },
      ],
    },
    testFormatSection: {
      header: "Password Skills Plus test format",
      desc: "The Password Skills Plus test consists of four test modules – reading, writing, listening and speaking. It takes three hours and five minutes to complete.",
      tableData: {
        rowHeader: ["Module", "Who can apply", "Description"],
        rowData: [
          {
            column1: "Password Reading",
            column2: "One hour and 15 minutes",
            column3:
              "Password Reading has five sections. Each section contains one task such as answering multiple-choice questions and reordering sentences to form a coherent paragraph.",
          },
          {
            column1: "Password Writing",
            column2: "30 minutes",
            column3:
              "Password Writing assesses your ability to write an essay. You have a choice of two essay titles to write an essay of at least 200 words.",
          },

          {
            column1: "Password Listening",
            column2: "One hour",
            column3:
              "Password Listening has five sections. In each section, you have to listen to multiple recordings and answer questions based on their contents. Once you press play, the recording cannot be paused or restarted. Each recording plays twice and questions appear on the second playback.",
          },
          {
            column1: "Password Listening",
            column2: "One hour",
            column3:
              "Password Listening has five sections. In each section, you have to listen to multiple recordings and answer questions based on their contents. Once you press play, the recording cannot be paused or restarted. Each recording plays twice and questions appear on the second playback.",
          },
        ],
      },
    },
  };

  return (
    <div className="password-eng-lan-tests">

      <LanguageLearnMore learnMoreData={learnMoreData} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
